//网络层工具类

import axios from 'axios'
import md5 from 'js-md5'
import { showDialog,showSuccessToast,showNotify } from 'vant';
import { useRouter } from 'vue-router'; //引入路由

var instance = axios.create({
  baseURL: 'https://wxapi.cyc.cn/API/', // https://localhost:44359   https://wxapi.cyc.cnhttps://localhost:44359/api/
  timeout: 60000, //超时 秒
  headers: { 'X-Custom-Header': 'foobar' }
});

// 添加响应拦截器
instance.interceptors.response.use(
  response => {
    //console.log('response.status:' + response.status);
    // 判断是否为成功的响应
    if (response.status === 200) {
      // 返回经过处理的响应数据
      return response.data;
    } else {
      showDialog({
        message: '接口服务器不可用',
      }).then(() => {
        // on close
      });
    }
  },

  // 对响应错误进行处理
  error => {
    // 对于请求错误或响应错误，应该给出友好的提示信息
    console.log('response.error:');
    console.log(error);
    
    //alert(error);
    if (error.message.includes('timeout')) {
      //return Promise.reject(new Error('请求超时'));
      showDialog({
        message: '接口请求超时',
      }).then(() => {
        // on close
      });
    }
    if (error.response) {
      const status = error.response.status;
      switch (status) {
        case 404:
          //return Promise.reject(new Error('请求接口不存在'));
          showDialog({
            message: '请求接口不存在',
          }).then(() => {
            // on close
          });
        case 400:
          showDialog({
            message: '请求接口失败',
          }).then(() => {
            // on close
          });
          break;
        default:
          return Promise.reject(new Error('服务器错误'));
      }
    } else {
      showDialog({
        message: '接口服务器不可用或你的手机没有打开网络',
      }).then(() => {
        // on close
      });
      //return Promise.reject(new Error('网络错误'));
    }
  }

);

//get方法
export const netUpload = async (url, formData ) => {
  //有token的请求就加入一个token
  let token = sessionStorage.getItem("Token");
  //console.log('token:'+token);
  /*
const file = fileInput.files[0];
const formData = new FormData();
formData.append('file', file)
  */
  let res = await axios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':'Bearer '+token
    }
  });

  if (res.Code == -1) {
    //服务器接口返回错误
    showDialog({
      message: res.Msg,
    }).then(() => {
      // on close
    });
  }
  return res;
}

//get方法
export const netGet = async (url, jsonObj) => {
  //有token的请求就加入一个token
  let token = sessionStorage.getItem("Token");
  if (token) {
    instance.defaults.headers.common['Token'] = token;
  }
  let res = await instance.get(url, { jsonObj });
  if (res.Code == -1) {
    //服务器接口返回错误
    showDialog({
      message: res.Msg,
    }).then(() => {
      // on close
    });
  }
  return res;
}
//post方法
export const netPost = async (url, jsonObj) => {
  //有token的请求就加入一个token
  let token = sessionStorage.getItem("Token");

  if (token) {
    instance.defaults.headers.common['Token'] = token;
  }
  //签名
  let timeSpan = new Date().getTime(); //时间戳
  //console.log(timeSpan);
  let sign = makrSign(timeSpan, jsonObj);
  instance.defaults.headers.common['TimeSpan'] = timeSpan;
  instance.defaults.headers.common['Sign'] = sign;
  let res = await instance.post(url, jsonObj);
  //console.log('netPost');
  //console.log(res);
  if (res) {
    if (res.Code == -1) {
      //服务器接口返回错误
      showDialog({
        message: res.Msg,
      }).then(() => {
        // on close
      });
    }
    if (res.Code == 401) {
      //服务器接口返回错误
      showDialog({
        message: res.Msg,
      }).then(() => {
        userReLogin();//重新登录
      });
    }
    return res;
  } else {
    let jsonObj = {
      Code: -99,
      Msg: '接口报错',
      JsonData: {}
    }
    return jsonObj;
  }
}

//签名
const makrSign = (timeSpan, jsonObj) => {
  var signStr = "";
  if (jsonObj) {
    var arrs = new Array();
    for (let key in jsonObj) {
      if(jsonObj[key]!=undefined){
        arrs.push(key);
      }
    }
    arrs.sort();
    for (let key in arrs) {
      signStr += arrs[key] + "&";
    }
  }
  signStr = signStr + timeSpan;
  signStr = signStr.toLowerCase().replace(' ', '');
 // console.log('signStr:'+signStr);
  //console.log(jsonObj);
  return md5(signStr);
}

//用户重新登录
const userReLogin = async () => {
  let _router = useRouter();
  if (localStorage.getItem("UserName") && localStorage.getItem("Pwd")) {
    var jsonObj = {
      UserName: localStorage.getItem("UserName"),
      Pwd: localStorage.getItem("Pwd")
    }
    let res = await netPost('User/Login', jsonObj); //User/Login
    console.log('重新登录');
    console.log(res);
    if (res.Code == 0) {
      sessionStorage.setItem("Token", res.JsonData.Token);//临时保存TOKEN
      sessionStorage.setItem("Refresh_token", res.JsonData.Refresh_token);//临时保存Refresh_token
      showSuccessToast('重新登录成功，请刷新当前页面');
    } else {
      showNotify({ type: 'warning', message: res.Msg });
      setTimeout(() => {
        _router.push('/login');
      }, 1000);
    }

  } else {
    //没有保存用户密码的，手动登录
    showNotify({ type: 'warning', message: '你没有登录' });
    setTimeout(() => {
      router.push('/login');
    }, 1000);
  }
}